import { IMachineListMachine } from '../../../interfaces/Dictionary.interfaces';
import { MachineType } from '../../../interfaces/Brand.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export interface IGetMachinesParams {
  searchParam: {
    tagId?: string;
    machineType?: MachineType;
    searchTerm?: string;
    brandId?: string;
    fields?: string;
  };
}

export const getMachines = ({ searchParam }: IGetMachinesParams): Promise<IMachineListMachine[]> => {
  const URLSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`/machines?${URLSearchParams}`);
};
